// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Settings.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  GetAllSettingsRequest,
  GetAllSettingsResponse,
  SetAllSettingsRequest,
  SetAllSettingsResponse,
} from "./Models/SettingsModels";

export const protobufPackage = "daisi.protos.v1";

export type SettingsProtoDefinition = typeof SettingsProtoDefinition;
export const SettingsProtoDefinition = {
  name: "SettingsProto",
  fullName: "daisi.protos.v1.SettingsProto",
  methods: {
    getAll: {
      name: "GetAll",
      requestType: GetAllSettingsRequest,
      requestStream: false,
      responseType: GetAllSettingsResponse,
      responseStream: false,
      options: {},
    },
    setAll: {
      name: "SetAll",
      requestType: SetAllSettingsRequest,
      requestStream: false,
      responseType: SetAllSettingsResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface SettingsProtoServiceImplementation<CallContextExt = {}> {
  getAll(
    request: GetAllSettingsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetAllSettingsResponse>>;
  setAll(
    request: SetAllSettingsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<SetAllSettingsResponse>>;
}

export interface SettingsProtoClient<CallOptionsExt = {}> {
  getAll(
    request: DeepPartial<GetAllSettingsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetAllSettingsResponse>;
  setAll(
    request: DeepPartial<SetAllSettingsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<SetAllSettingsResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
